import { PercentPipe } from './percent.pipe';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { Utils } from '../utils';

@Pipe({ name: 'trPercentSignus' })
@Injectable({ providedIn: 'root' })
export class PercentSignusPipe implements PipeTransform {
  constructor(private percentPipe: PercentPipe) {}

  transform(value: number, digitsInfo?: string): string {
    if (!Utils.isValue(value)) return '--';

    let num = this.percentPipe.transform(value, digitsInfo);

    if (value > 0) {
      num = '+' + num;
    }

    return num;
  }
}
